export enum NodeType {
    START = 'nodeStart',
    TIME_VALIDATION = 'timeValidation',
    OPEN_EDGE = 'openEdge',
    PLAY_AUDIO = 'playAudio',
    CLIENT_INFO = 'clientInfo',
    CONNECT_FLOW_CUSTOM = 'connectFlowCustom',
    TRANSFER_EXTENSION = 'transferToExtension',
    TRANSFER_EXTERNAL = 'transferToExternal',
    TRANSFER_QUEUE = 'transferToQueue',
    TRANSFER_VIRTUAL_AGENT = 'transferVirtualAgent',
    TRANSFER_SURVEY = 'transferToSurvey',
    HANG_UP = 'hangUp',
    GO_TO = 'goTo',
    GO_TO_CONNECT_FLOW = 'goToConnectFlow',
}
